// given a user object with participants, sort by registration date and return the most recently registered participant

interface ParticipantProps {
  registrationDate: string;
}

export default function getCurrentParticipant<T extends ParticipantProps>(user: {
  participants: T[];
}): T {
  return user.participants?.sort(
    (a, b) => Date.parse(b.registrationDate) - Date.parse(a.registrationDate),
  )[0];
}
